import { normalizeUiLocale } from "@/i18n/catalog";
import {
  isStaticI18nEnabled,
  readInitialUiLocale,
  saveUiLocale,
} from "@/i18n/common/index";

const enabled = isStaticI18nEnabled(
  process.env.NODE_ENV,
  process.env.VUE_APP_STATIC_I18N_ENABLED
);

const browserStorage = () =>
  typeof window === "undefined" ? null : window.localStorage;

export default {
  namespaced: true,
  state: () => ({
    enabled,
    uiLocale: enabled
      ? readInitialUiLocale(
          browserStorage(),
          typeof navigator === "undefined" ? "zh-CN" : navigator.language
        )
      : "zh-CN",
  }),
  mutations: {
    setUiLocale(state, locale) {
      if (!state.enabled) return;
      const normalized = normalizeUiLocale(locale);
      if (normalized) state.uiLocale = normalized;
    },
  },
  actions: {
    chooseUiLocale({ commit }, locale) {
      if (!enabled) return null;
      const normalized = saveUiLocale(locale, browserStorage());
      if (normalized) commit("setUiLocale", normalized);
      return normalized;
    },
  },
};
